import { render, staticRenderFns } from "./RegPhone.vue?vue&type=template&id=592dfc51&scoped=true"
import script from "./RegPhone.vue?vue&type=script&lang=js"
export * from "./RegPhone.vue?vue&type=script&lang=js"
import style0 from "./RegPhone.vue?vue&type=style&index=0&id=592dfc51&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "592dfc51",
  null
  
)

export default component.exports